export const PerPhaseNames = [
    { code: 'Ap', name: 'A. Productiefase', shortName: 'Fase A prod' },
    { code: 'Ac', name: 'A. Constructiefase', shortName: 'Fase A constr' },
    { code: 'B', name: 'B. Gebruiksfase', shortName: 'Fase B' },
    { code: 'C', name: 'C. Afdankfase', shortName: 'Fase C' },
    { code: 'D', name: 'D. Buiten levensloop', shortName: 'Fase D' }
]